export default "/list/static/images/CheapTickets_Logo_RGB.svg";